export default  {
  bindings: {
    days: '<',
    categories: '<'
  },
  controller: 'dayListController',
  template: require('../views/day.list.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/days/components/day.list.component.js